export const MAX_CUSTOM_CODES = 15;
export const CUSTOM_CODE_MAX_LENGTH = 50;

// Message used for in-row duplicate detection. Exported (and matched exactly)
// so the prune helper can identify which errors are derived purely from local
// state and safe to recompute — API/UPC/cross-variant errors stay untouched.
export const LOCAL_DUPLICATE_MSG = "Already in this list";

// Drop "Already in this list" entries whose row no longer has a matching peer
// in `values` (case-insensitive, trimmed). Called whenever values change so a
// removed/edited peer doesn't leave the survivor pinned with a stale error
// that would block save in checkFormErrorExist. Returns the same `errors`
// reference when nothing changed so React skips unnecessary re-renders.
export const pruneStaleLocalDuplicateErrors = (values, errors) => {
  if (!errors) return errors || {};
  const keys = Object.keys(errors);
  if (keys.length === 0) return errors;
  const arr = Array.isArray(values) ? values : [];
  let out = errors;
  let mutated = false;
  for (const key of keys) {
    if (errors[key] !== LOCAL_DUPLICATE_MSG) continue;
    const i = Number(key);
    const v = arr[i];
    const trimmed = typeof v === "string" ? v.trim().toLowerCase() : "";
    const hasDup =
      !!trimmed &&
      arr.some(
        (other, j) =>
          j !== i &&
          typeof other === "string" &&
          other.trim().toLowerCase() === trimmed
      );
    if (!hasDup) {
      if (!mutated) {
        out = { ...errors };
        mutated = true;
      }
      delete out[key];
    }
  }
  return out;
};

export const parseCustomCode = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((v) => (v == null ? "" : String(v).trim()))
      .filter(Boolean);
  }
  if (value === null || value === undefined || value === "") return [];
  return String(value)
    .split("|")
    .map((s) => s.trim())
    .filter(Boolean);
};

export const serializeCustomCodes = (codes) => {
  if (!Array.isArray(codes)) return "";
  return codes
    .map((c) => (c == null ? "" : String(c).trim()))
    .filter(Boolean)
    .join("|");
};
